import * as React from 'react'
import { connect } from 'react-redux'
import { History } from 'history'
import { GetReferralDataResponse, GetScratchCardResponse, InvitedFriendsResponse, PageProps } from '@logic'
import { RouteComponentProps, withRouter } from 'react-router'
import { loadAllScratchCards, loadInvitedFirends, loadReferralsData } from '@shared/helpers'
import { withLoadingCachedMultiple } from '@shared/components/loading'
import { MyReferralsShared } from '../components/referral-component'

interface StateProps extends RouteComponentProps<any> {
  user: any
  history: History
}

type ExternalProps = PageProps & StateProps
type LoadedProps = GetReferralDataResponse & InvitedFriendsResponse & GetScratchCardResponse
type Props = ExternalProps & LoadedProps

const emptyReferralData: GetReferralDataResponse = {
  userDetails: {
    email: '',
    equaCash: 0,
    noofref: 0,
    position_ahead: 0,
    position_behind: '',
    referralLink: '',
    status: 0,
    username: '',
  },
}

const emptyInvitationData: InvitedFriendsResponse = {
  invitationDetails: {
    invitations: [],
    dailyInvitation: 0,
    monthlyInvitation: 0,
    totalCompletedInvitation: 0,
    totalInvitations: 0,
    totalPendingInvitation: 0,
  },
}

const emptyScratchCardData: GetScratchCardResponse = {
  rewardDetails: {
    dailyReward: 0,
    monthlyReward: 0,
    dailyTicket: 0,
    monthlyTicket: 0,
    rewards: [],
    totalReward: 0,
  },
  orgRewards: { orgTickets: [] },
}

export const loadMyReferralsPageData = async (props: ExternalProps): Promise<LoadedProps> => {
  const referralData = await loadReferralsData(props)
  const [invitationData, scratchCardData] = await Promise.all([
    loadInvitedFirends(props),
    loadAllScratchCards()(props),
  ])

  return {
    ...(referralData ?? emptyReferralData),
    ...(invitationData ?? emptyInvitationData),
    ...(scratchCardData ?? emptyScratchCardData),
  }
}

const withData = withLoadingCachedMultiple<LoadedProps, ExternalProps>(loadMyReferralsPageData)

const MyReferralsComponent = withData((props: Props) => {
  return <MyReferralsShared {...props} />
})

const mapStateToProps = (state: any) => ({
  user: state.user,
})

export const MyReferrals = withRouter(
  connect(
    mapStateToProps,
    {}
  )(MyReferralsComponent)
)
